
import { Component, Vue } from "vue-property-decorator";
import { IMenuItem } from "./menuItem.interface";

@Component({
  name: "MenuItem",
  props: {
    value: {
      type: Object as () => IMenuItem,
      required: true,
    },
  },
})
export default class MenuItem extends Vue {
  private clicked = 0;

  get mobileViewport() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  handleItemClick() {
    if (this.$props.value.link instanceof Function) {
      this.$props.value.link(this.$props.value.id);
    } else {
      this.$router.push(this.$props.value.link).catch(() => undefined);
      // close drawer
      this.$emit("closeDrawer");
    }
  }
}
